import UpcomingEventsSidebar from "../../UpcomingEventsSidebar/UpcomingEventsSidebar"
import EventProvider from "../provider/EventProvider"
import EventCategories from "./Categories"
import EventList from "./List"
import EventsSearchBox from "./SearchBox"

export type EventsModel = {
  source: number,
  pageSize: number,
  numberOfMonths: number
  defaultImage: string,
  resultMessage: string,
  noResultMessage: string
}

export default function Events({ source, pageSize, numberOfMonths, defaultImage, resultMessage, noResultMessage }: EventsModel) {
  return (
    <EventProvider source={source} pageSize={pageSize} numberOfMonths={numberOfMonths}>
      <div className="grid-x grid-margin-x">
        <div className="cell small-12 medium-8">
          <div className="event-list-wrapper">
            <EventList defaultImage={defaultImage} />
          </div>
        </div>
        <div className="cell small-12 medium-4">
          <div className="sidebar">
            <EventsSearchBox resultMessage={resultMessage} noResultMessage={noResultMessage} />
            <UpcomingEventsSidebar source={source} numberOfMonths={numberOfMonths} />
            <EventCategories />
          </div>
        </div>
      </div>
    </EventProvider>
  )
}